<template>
	<div>
		<div class="title">
			<div class="title">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ $t("variables") }}</h1>
					</div>

					<div class="header_actions">
						<div class="header_actions-container">
							<option-button
								:show="true"
								:buttons="buttons"


								@restore="handleRestore"
								@archive="handleDelete(true)"


								@clear="selecteds = []"
								@add="add = true"
								:csvEntity="'customfields'"
								:csvHeader="csvHeader"
								:csvFilters="getFilters"
								:processCsv="processCsv"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex; width: 100%; margin-bottom: 10px">
			<el-input
				v-model="filter.text"
				style="width: 40%; margin-top: auto; margin-bottom: auto"
				:placeholder="$t('search-something')"
				clearable
				@keyup.enter.native="handleSearch(false)"
			/>
			<el-select style="width: 60%" :placeholder="$t('level')" v-model="filter.level" multiple value-key="level">
				<el-option v-for="(level, index) in levels" :key="index" :value="level.level" :label="level.name" />
			</el-select>
			<el-button
				icon="el-icon-search"
				type="primary"
				@click="handleSearch(false)"
				style="margin-top: auto; margin-bottom: auto; width: 75px; margin-left: auto; margin-right: 0"
			/>
			<el-button
				type="warning"
				v-if="searching"
				style="margin-top: auto; margin-bottom: auto; width: 75px; margin-left: auto; margin-right: 0"
				icon="el-icon-close"
				@click="handleSearch(true)"
			/>
		</div>
		<div v-if="array" style="display: flex">
			<app-deleted-items :deleted_at="deleted_at" @change="v => (deleted_at = v)" />
			<app-total
				:start="pagination.offset"
				:end="pagination.offset + variables.array.length"
				:total="variables.count"
			/>
		</div>
		<div
			style="overflow-y: scroll !important"
			:style="{ height: height + 'px' }"
			v-loading="loading"
			v-if="variables"
			class="md-content md-table md-theme-default"
		>
			<md-table v-model="variables.array">
				<md-table-row
					slot="md-table-row"
					slot-scope="{ item }"
					:key="item.id"
					md-selectable="single"
					@click="() => rowClick(item)"
				>
					<md-table-cell width="25">
						<md-checkbox
							:id="item.id"
							v-model="selecteds"
							:value="item"
							@click="e => e.stopPropagation()"
						></md-checkbox>
					</md-table-cell>
					<md-table-cell :md-label="$t('name').toUpperCase()">{{ item.name }}</md-table-cell>
					<md-table-cell :md-label="$t('type').toUpperCase()">{{ $t(item.type) }}</md-table-cell>
					<md-table-cell :md-label="$t('level').toUpperCase()">
						<el-tag v-if="item.level == -1">{{ getLevelTag(-1) }}</el-tag>
						<el-tag v-else-if="item.level == 0">{{ getLevelTag(0) }}</el-tag>
						<el-tag v-else-if="item.level == 1">{{ getLevelTag(1) }}</el-tag>
						<el-tag v-else-if="item.level == 2">{{ getLevelTag(2) }}</el-tag>
						<el-tag v-else-if="item.level == 3">{{ getLevelTag(3) }}</el-tag>
					</md-table-cell>
					<md-table-cell :md-label="$t('rules').toUpperCase()" style="width: 50px">
						<el-tag
							v-for="(rule, key) in item.rules"
							:key="item.id + key"
							class="truncated-tags"
							type="info"
							size="small"
							>{{ $t(key) }}: {{ rule }}</el-tag
						>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>

		<div style="display: flex; width: 100%">
			<div style="display: flex">
				<!-- <option-button
					:show="true"
					:buttons="buttons"
					@clear="selecteds = []"
					@add="add = true"
					:csvEntity="'customfields'"
					:csvHeader="csvHeader"
					:csvFilters="getFilters"
					:processCsv="processCsv"
				/> -->
			</div>
			<div style="margin-left: auto; margin-right: 0; margin-top: 10px; margin-bottom: auto">
				<app-pagination
					:tot="variables.count"
					:size="pagination.size"
					:offset="pagination.offset"
					@fetch="doFetch"
				/>
			</div>
		</div>

		<variables-add :show="add" @close="add = false" @add="handleAdd" />
	</div>
</template>

<script>
import moment from "moment"
import addButton from "@/modules/_common/button/add-button.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"
import AppPagination from "@/modules/_common/table/app-pagination.vue"
import OptionTableButton from "@/modules/_common/button/option-table-button.vue"
import VariablesAdd from "@/modules/datas/variables/variables-components/variables-add.vue"
import AppTotal from "@/modules/_common/table/app-total.vue"
import { mapGetters, mapActions } from "vuex"
import DeletedItems from "@/modules/_common/table/app-deleted-items.vue"
import axios from 'axios'

export default {
	components: {
		addButton,
		OptionButton,
		AppPagination,
		OptionTableButton,
		VariablesAdd,
		"app-total": AppTotal,
		"app-deleted-items": DeletedItems
	},
	name: "variables-list",
	data() {
		return {
			height: window.innerHeight - 320,
			array: [],
			levels: [
				{ level: -1, name: this.$t("required-tag") },
				{ level: 0, name: this.$t("global-tag") },
				{ level: 1, name: this.$t("project-tag") },
				{ level: 2, name: this.$t("procedure-tag") },
				{ level: 3, name: this.$t("document-tag") }
			],
			filter: {
				text: "",
				level: [-1, 0, 1, 2, 3]
			},
			deleted_at: false,
			selecteds: [],
			buttons: ["add", "option", "option-csv"],
			loading: false,

			// SINGLE ELEMENT DETAILS
			searching: true,
			add: false,

			//CSV
			csvHeader: [
				this.$t("id"),
				this.$t("name"),
				this.$t("type"),
				this.$t("level"),
				this.$t("rules"),
				this.$t("created-at"),
				this.$t("updated-at"),
				this.$t("deleted-at")
			]
		}
	},
	computed: {
		...mapGetters({
			variables: "variable/variables",
			pagination: "variable/pagination"
		})
	},
	watch: {
		selecteds: function () {
			if (this.selecteds.length > 0) {
				if (this.selecteds.every(el => el.deleted_at != undefined)) this.buttons = ["clear", "restore"]
				else this.buttons = ["clear", "archive"]
			} else {
				this.buttons = ["add", "option", "option-csv"]
			}
		},
		deleted_at: function () {
			this.doFetch(1, this.pagination.size)
		},
		variables: function () {
			this.loading = false
		}
	},
	created() {
		this.handleSearch(false)
		this.doVariables()
	},

	methods: {
		...mapActions({
			doGetVariables: "variable/doGet",
			doMutate: "variable/doMutate",
			doVariables: "modules/doVariables"
		}),
		getLevelTag: function (level) {
			switch (level) {
				case -1:
					return this.$t("required-tag")
				case 0:
					return this.$t("global-tag")
				case 1:
					return this.$t("project-tag")
				case 2:
					return this.$t("procedure-tag")
				case 3:
					return this.$t("document-tag")
			}
			return ""
		},
		trimRule(rule) {
			if (Array.isArray(rule)) return rule.length > 25 ? rule.substring(0, 25) + "..." : rule
			else return rule.toString().length > 25 ? rule.toString().substring(0, 25) + "..." : rule.toString()
		},
		async handleSearch(reset) {
			this.searching = !reset

			if (!this.searching) {
				this.filter.text = ""
				this.filter.level = [-1, 0, 1, 2, 3]
			}
			await this.doFetch(1, this.pagination.size)
		},
		handleEdit: function (variable) {
			this.array.forEach((el, i, a) => {
				if (el.id == variable.id) {
					a[i] = variable
					a[i].rules = variable.rules
				}
			})
		},
		handleAdd: function (variable) {
			this.add = false
			this.array.push(variable)
		},
		rowClick: function (item) {
			this.doMutate({ element: "variable", value: item })
			this.$router.push({ path: "/datas/variables/" + item.id })
		},

		doFetch: function (page, size) {
			var filters = this.getFilters(true, page, size)
			this.doMutate({
				element: "pagination",
				value: { size: filters.pagination.size, offset: filters.pagination.offset }
			})
			this.get(filters)
		},

		get(filters) {
			this.loading = true
			this.doGetVariables(filters)
		},

		getFilters(withFilters, page = undefined, size = undefined) {
			if (!withFilters)
				return {
					levels: [-1, 0, 1, 2, 3],
					filter: "",
					exact: false,
					pagination: {
						deleted_at: true
					}
				}

			if (size && page) {
				this.pagination.size = size
				this.pagination.offset = (page - 1) * this.pagination.size
				this.doMutate({ element: size, value: size })
			}

			var filters = {
				levels: this.filter.level.length == 0 ? [-1, 0, 1, 2, 3] : this.filter.level,
				filter: this.filter.text,
				exact: false,
				pagination: {
					deleted_at: this.deleted_at
				}
			}

			if (size && page) {
				filters.pagination.offset = this.pagination.offset
				filters.pagination.size = this.pagination.size
			}

			return filters
		},
		processCsv: function (item) {
			var data = []

			data.push("id: " + item.id)
			data.push('"' + item.name.replace(/"/g, '""') + '"')
			data.push(this.$t(item.type))

			data.push(this.$t(this.getLevelTag(item.level)))
			data.push('"' + item.rules.replace(/"/g, '""') + '"')

			data.push(moment(item.created_at).format("DD/MM/YYYY HH:mm:ss"))
			data.push(item.updated_at ? moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss") : "-")
			data.push(item.deleted_at ? moment(item.deleted_at).format("DD/MM/YYYY HH:mm:ss") : "-")

			return data
		},
		handleRestore: function (value, item) {
			var array = []
			if (this.selecteds.length == 0 && item != undefined) array = [item]
			else array = this.selecteds

			axios
			.post(
				process.env.VUE_APP_API_URL + "/api/customfields/batchRestore",
				{ array: array },
				{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
			)
			.then(res => {
				this.selecteds.forEach(el => {
					el.deleted_at = undefined
				})
				this.$notification("success", this.$t("restored-successfully"), "", 4000)
				this.selecteds = []
			})
			.catch(err => {
				this.$processError(this.$t("save-error"), err.response.data.Message)
				console.error(err)
			})
		},
		handleDelete: function (value, item) {
			var array = []
			if (this.selecteds.length == 0 && item != undefined) array = [item]
			else array = this.selecteds

			axios
			.post(
				process.env.VUE_APP_API_URL + "/api/customfields/batchDelete",
				{ array: array },
				{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
			)
			.then(res => {
				this.selecteds.forEach(el => {
					el.deleted_at = new Date()
				})
				this.$notification("success", this.$t("deleted-successfully"), "", 4000)
				this.selecteds = []
				// ho provato a farlo con lo slice, l'array cambia effettivamente ma md-table non mostra gli update dei dati
				// array.map(i => this.array.splice(this.array.findIndex(x => x.id === i), 1))
				// ergo svuoto e ripopolo da db
				this.array = []
				this.handleSearch(false)
				this.doVariables()
			})
			.catch(err => {
				this.$processError(this.$t("delete-error"), err.response.data.Message)
				console.error(err)
			})
		},
	}
}
</script>
<style lang="scss" scoped>
@import "src/assets/scss/my-menu";

.truncated-tags {
	margin: 5px;
	max-width: 500px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
